import React from 'react';
import ReactPaginate from 'react-paginate';
import './style.css';

const ChrPaginate = props => {
  const pageCount = Math.ceil(props.totalEntries / props.perPage);

  return(
    <ReactPaginate
      containerClassName="pagination"
      activeClassName="active"
      pageClassName="page-item"
      onPageChange={ props.onPageChangeHandler }
      breakLabel="..."
      pageCount={ pageCount }
      previousLabel={ <i className="fa-regular fa-angle-left"/> }
      nextLabel={ <i className="fa-regular fa-angle-right"/> }
      pageLinkClassName="page-link"
      forcePage={ Math.min(props.forcePage, pageCount - 1) }
    />
  )
}

export default ChrPaginate;